import React, { ReactElement } from 'react';
import {
  IDays,
  IHolidays,
  IHolidaysList,
} from '../TalkWithUsModal/TalkWithUsModal.types';
import { constant } from './constant';
import {
  Heading,
  Rank,
  Sizes,
  TextBoldness,
  Typography,
  FlexGrid,
  getClassNameFactory,
} from '@dcl/ui';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { v4 as uuid } from 'uuid';
import './Holidays.css';

const Holidays: React.FC<IHolidaysList> = ({ holidays }): ReactElement => {
  const getClassName = getClassNameFactory(Holidays.displayName);
  return (
    <div className={getClassName()}>
      <Heading
        type={types.XtraSmall}
        boldType={boldTypes.black}
        rank={Rank.Second}
        className={getClassName({ descendantName: 'heading' })}
      >
        {constant.thHolidayHeading}
      </Heading>
      <Typography
        type={Sizes.XXXTRASMALL}
        tag={TypographyTags.P}
        className={getClassName({ descendantName: 'supportText' })}
      >
        ({constant.supportClosedText})
      </Typography>

      {holidays?.map((holiday: IHolidays) => {
        return (
          <FlexGrid
            key={holiday.countryName}
            className={getClassName({ descendantName: 'grid' })}
          >
            <FlexGrid.Row>
              <table className={getClassName({ descendantName: 'table' })}>
                <caption
                  className={getClassName({ descendantName: 'tableCaption' })}
                >
                  <Typography
                    type={Sizes.XTRASMALL}
                    tag={TypographyTags.P}
                    boldness={TextBoldness.Black}
                  >
                    {holiday.countryName}
                  </Typography>
                </caption>
                <thead>
                  <tr>
                    <th>
                      <Typography
                        type={Sizes.XXTRASMALL}
                        tag={TypographyTags.P}
                        boldness={TextBoldness.Black}
                        className={getClassName({
                          descendantName: 'text',
                        })}
                      >
                        {constant.holidayText}
                      </Typography>
                    </th>
                    <th>
                      <Typography
                        type={Sizes.XXTRASMALL}
                        tag={TypographyTags.P}
                        boldness={TextBoldness.Black}
                        className={getClassName({
                          descendantName: 'text',
                        })}
                      >
                        {constant.dateText}
                      </Typography>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {holiday.days.map((day: IDays) => {
                    return (
                      <tr key={uuid()}>
                        <td
                          className={getClassName({
                            descendantName: 'heading',
                          })}
                        >
                          <Typography
                            type={Sizes.XXTRASMALL}
                            tag={TypographyTags.P}
                            className={getClassName({
                              descendantName: 'text',
                            })}
                          >
                            {day.holidayName}
                          </Typography>
                        </td>
                        <td>
                          <Typography
                            type={Sizes.XXTRASMALL}
                            tag={TypographyTags.P}
                            className={getClassName({
                              descendantName: 'text',
                            })}
                          >
                            {day.holidayDate}
                          </Typography>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </FlexGrid.Row>
          </FlexGrid>
        );
      })}
    </div>
  );
};

Holidays.displayName = 'Holidays';

export default Holidays;
